var map = {
	"./BestDryCleanerInPrayagraj": [
		8642,
		642
	],
	"./BestDryCleanerInPrayagraj/": [
		8642,
		642
	],
	"./BestDryCleanerInPrayagraj/index": [
		8642,
		642
	],
	"./BestDryCleanerInPrayagraj/index.tsx": [
		8642,
		642
	],
	"./Home": [
		1082,
		82
	],
	"./Home/": [
		1082,
		82
	],
	"./Home/index": [
		1082,
		82
	],
	"./Home/index.tsx": [
		1082,
		82
	],
	"./PrivacyPolicy": [
		5768,
		768
	],
	"./PrivacyPolicy/": [
		5768,
		768
	],
	"./PrivacyPolicy/index": [
		5768,
		768
	],
	"./PrivacyPolicy/index.tsx": [
		5768,
		768
	],
	"./TermsAndConditions": [
		6859,
		859
	],
	"./TermsAndConditions/": [
		6859,
		859
	],
	"./TermsAndConditions/index": [
		6859,
		859
	],
	"./TermsAndConditions/index.tsx": [
		6859,
		859
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;